import { Select } from 'antd';
import DigitalcoinUtil from '$ACTIONS/DigitalcoinUtil';
import AddDigitalCoinWalletAddress from '@/BankAccount/AddDigitalCoinWalletAddress';

const { Option } = Select;

let DigitalCoinTrait;
export default DigitalCoinTrait = (that, isNeedPopupAddWalletModal=true) => {
    const DEFAULT_ERROR_BOOLEAN = false;
    const defaultAvailableDigitalCoinMethods = [];
    let availableDigitalCoinMethods = defaultAvailableDigitalCoinMethods;

    /*
    that.digitalCoinWalletRegExpTest = (evt, conf={}) => {
        let { digitalcoinMethod: m } = that.state;
        let val = evt.target.value, func = WALLET_REGEXP_MAP[m||'X'] || v=>{};
        that.setState({tDBAddress: val}, () => {
            that.setState({tDBAddressError: func ? func() : true })
        })
    };*/
    return {
        DEFAULT_ERROR_BOOLEAN,
        init: () => {
            if (isNeedPopupAddWalletModal) {
                that.state.visibleDigitalCoinWallet = false;
                that.state.tDBAddressErrorDigitalCoin = DEFAULT_ERROR_BOOLEAN; // default: false
            }
        },
        getAvailableMethod: () => availableDigitalCoinMethods, // [{methodType: "EBpay Withdrawal", methodCode: "EBpay_WD", isNew: false}, ...]
        setAvailableMethod: a => { availableDigitalCoinMethods = a || defaultAvailableDigitalCoinMethods; }, // [{methodType: "EBpay Withdrawal", methodCode: "EBpay_WD", isNew: false}, ...]
        renderSelect: (digitalcoinWithdrawType, digitalcoinMethod, params={}) => {
            let moreClassName = ' at-withdrawal-dialog-modal';
            if (params?.useHardCode) {
                moreClassName = ''; // ' at-add-digitalcoin-wallet-dialog-modal';
            }
            let moreAttr = {}
            if (true) {
                moreAttr.key = 'SelectKey' + Math.random().toString().replace('.','')
            }
            return (<Select
                    {...moreAttr}
                    disabled={digitalcoinWithdrawType.length<=1}
                    defaultValue={digitalcoinWithdrawType.length===1 ? digitalcoinWithdrawType[0] : (digitalcoinMethod||undefined)}
                    placeholder={'请选择代币钱包'}
                    className={'alike-digital-coin-select' + moreClassName}
                    onChange={code => params?.onChangeFunc ? params.onChangeFunc(code) : that.changeErcTrc(code, false)}
                >{digitalcoinWithdrawType.map(item => {
                    let source = params?.useHardCode ? digitalcoinWithdrawType : availableDigitalCoinMethods;
                    let txt = source.length ? (params?.useHardCode ? DigitalcoinUtil.getHardCodeNameByCoinType(item) : DigitalcoinUtil.getNameByCoinType(availableDigitalCoinMethods, item)) : '--';
                    return (<Option key={item} value={item}>
                            <div style={{textAlign:'left'}}>
                                <img src={"/cn/img/DIGITALCOIN/" + item + ".svg"} alt="" style={{float:'left',width:32,height:32}} />
                                <span style={{display:'inline-block',width:6}} />
                                <i style={{fontStyle:'normal'}}>{txt}</i>
                            </div>
                        </Option>)
                })}
                </Select>)
        },
        renderAddModal: () => {
            let {visibleDigitalCoinWallet, addTDBBtnStatue, tDBName, tDBAddress, tDBAddressErrorDigitalCoin, tDBAddressError2, aryDigitalCoin} = that.state;
            return <AddDigitalCoinWalletAddress // 添加 DigitalCoin 钱包地址
                    aryAddedDigitalCoin={aryDigitalCoin||[]}
                    visibleDigitalCoinWallet={visibleDigitalCoinWallet}
                    leaveAddWallet={() => that.setState({ leaveAddWalletVisible: true })}
                    digitalCoinWalletRegExpTest={that.digitalCoinWalletRegExpTest}
                    handleOk={()=>that.handleOk({curCoinType:tDBName})}
                    addTDBBtnStatue={addTDBBtnStatue}
                    meAt={that.openAddDCWalletModalAt||''}
                    tDBName={tDBName}
                    tDBAddress={tDBAddress}
                    tDBAddressError={tDBAddressErrorDigitalCoin}
                    tDBAddressError2={tDBAddressError2}
                />
        },
    }
}
